import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1b709c2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "card mb-25 border-0 rounded-0 bg-white number-of-tickets-box",
  id: "chartCard"
}
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-sm-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "d-sm-flex align-items-center justify-content-between" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "card-title fw-bold mb-0" }, "Order Data Overview", -1))
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = {
  key: 0,
  class: "card-select me-2"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "minute" }, "Minute", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "day" }, "Day", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "month" }, "Month", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "year" }, "Year", -1))
const _hoisted_11 = [
  _hoisted_7,
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  class: "dropdown ellipsis-menu",
  ref: "ellipsisMenu"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "dropdown-toggle card-dot-btn lh-1 position-relative top-4 bg-transparent border-0 shadow-none p-0 transition",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-dots" })
], -1))
const _hoisted_14 = { class: "dropdown-menu dropdown-menu-end" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-download lh-1 me-8 position-relative top-1" }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-download lh-1 me-8 position-relative top-1" }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-code lh-1 me-8 position-relative top-1" }, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-code lh-1 me-8 position-relative top-1" }, null, -1))
const _hoisted_19 = {
  id: "orderDataChart",
  class: "chart"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          (!_ctx.isEmbed)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _withDirectives(_createElementVNode("select", {
                  class: "form-select shadow-none text-black border-0 ps-0 pt-0 pb-0 pe-20 fs-14 fw-medium",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedPeriod) = $event)),
                  onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.fetchChartData && _ctx.fetchChartData(...args)))
                }, _hoisted_11, 544), [
                  [_vModelSelect, _ctx.selectedPeriod]
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isEmbed)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("ul", _hoisted_14, [
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      class: "dropdown-item d-flex align-items-center",
                      href: "javascript:void(0);",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.exportChart('png')))
                    }, [
                      _hoisted_15,
                      _createTextVNode(" Export as PNG ")
                    ])
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      class: "dropdown-item d-flex align-items-center",
                      href: "javascript:void(0);",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.exportChart('jpg')))
                    }, [
                      _hoisted_16,
                      _createTextVNode(" Export as JPG ")
                    ])
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      class: "dropdown-item d-flex align-items-center",
                      href: "javascript:void(0);",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.exportChartAsIframe && _ctx.exportChartAsIframe(...args)))
                    }, [
                      _hoisted_17,
                      _createTextVNode(" Export as Iframe ")
                    ])
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      class: "dropdown-item d-flex align-items-center",
                      href: "javascript:void(0);",
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.manageIframe && _ctx.manageIframe(...args)))
                    }, [
                      _hoisted_18,
                      _createTextVNode(" Manage Iframe (" + _toDisplayString(_ctx.embedCount) + ") ", 1)
                    ])
                  ])
                ])
              ], 512))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createVNode(_component_apexchart, {
          type: "bar",
          height: "300",
          options: _ctx.chartOptions,
          series: _ctx.series
        }, null, 8, ["options", "series"])
      ])
    ])
  ]))
}